import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon, LockIcon, ShieldIcon, BadgeIcon } from './icons';
export const Close: React.FC = () => {
  return <section className="py-24 px-6 sm:px-8 lg:px-12 max-w-5xl mx-auto border-t border-gold/30" data-id="element-1">
      <div className="text-center mb-16" data-id="element-2">
        <span className="text-xs font-bold tracking-[0.2em] text-gold uppercase block mb-4" data-id="element-3">
          Two Paths
        </span>
        <h2 className="font-serif text-4xl sm:text-5xl text-forest-dark" data-id="element-4">
          The Choice Is Yours.
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-5">
        {/* Path A */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 rounded-xl border border-charcoal/10 opacity-70 grayscale-[30%]" data-id="element-6">
          <h3 className="font-serif text-2xl text-charcoal/60 mb-4 flex items-center gap-2" data-id="element-7">
            <XIcon className="w-6 h-6" data-id="element-8" /> Path A: Do Nothing
          </h3>
          <p className="text-charcoal/60 leading-relaxed" data-id="element-9">
            Keep doing what you're doing, feeding the same processed food and
            hoping for the best while the gray muzzle grows faster. Ignore the
            science and cross your fingers.
          </p>
        </motion.div>

        {/* Path B */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-forest p-8 rounded-xl border-2 border-gold shadow-2xl relative" data-id="element-10">
          <div className="absolute -top-4 -right-4 bg-gold text-forest-dark text-xs font-bold uppercase tracking-wider px-3 py-1 rounded shadow-md" data-id="element-11">
            Recommended
          </div>
          <h3 className="font-serif text-2xl text-cream mb-4 flex items-center gap-2" data-id="element-12">
            <CheckIcon className="w-6 h-6 text-gold" data-id="element-13" /> Path B: Take Action
          </h3>
          <p className="text-cream/90 leading-relaxed" data-id="element-14">
            Spend 10 minutes a day and $37 once to give your best friend the
            biological gift of time. Switch off disease genes and unlock "puppy
            energy" using simple grocery items.
          </p>
        </motion.div>
      </div>

      <div className="text-center max-w-2xl mx-auto" data-id="element-15">
        <a href="https://govitalpaw.com/cart/46877566664892:1" target="_blank" rel="noopener noreferrer" className="w-full bg-forest hover:bg-forest-dark text-cream font-bold text-lg sm:text-xl px-8 py-5 rounded shadow-xl transition-all hover:-translate-y-1 mb-6 flex flex-col items-center justify-center gap-1" data-id="element-16">
          <span data-id="element-17">YES — I WANT MY DOG TO LIVE LONGER</span>
          <span className="text-sm font-normal text-cream/70" data-id="element-18">
            ACCESS NOW FOR $37
          </span>
        </a>

        <div className="flex flex-wrap justify-center items-center gap-4 sm:gap-8 text-xs font-medium text-charcoal/60 uppercase tracking-wider" data-id="element-19">
          <div className="flex items-center gap-1.5" data-id="element-20">
            <LockIcon className="w-4 h-4 text-gold" data-id="element-21" /> Secure Checkout
          </div>
          <div className="flex items-center gap-1.5" data-id="element-22">
            <BadgeIcon className="w-4 h-4 text-gold" data-id="element-23" /> 60-Day Guarantee
          </div>
          <div className="flex items-center gap-1.5" data-id="element-24">
            <ShieldIcon className="w-4 h-4 text-gold" data-id="element-25" /> Instant Access
          </div>
        </div>
      </div>
    </section>;
};